import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('medical_benefits_set', '/medical_benefits_sets', 'benefits_set')
const reducer = generator.generate()

export default reducer
